function AutoScroll(obj) {
  $(obj).find("ul:first").animate({
    marginTop: "-25px"
  }, 500, function() {
    $(this).css({
      marginTop: "0px"
    }).find("li:first").appendTo(this);
  });
}
$(document).ready(function() {
  setInterval('AutoScroll("#giftScroll")', 5000);
});


$('.active-rule-more').click(function (e) { 
  e.preventDefault();
  let more = $(this).data('more');
  let less = $(this).data('less');
  $(this).prev().toggleClass('on')
  $(this).toggleClass('on');
  $(this).hasClass('on') ? $(this).find('span').text(less) : $(this).find('span').text(more)
});

let time = $('.active-countdown').data('time');
$(`#countdown`).timeTo({
  timeTo: new Date(time),
  theme: "black",
  displayDays: 2,
  displayCaptions: true,
  fontSize: !isMobile() ? 35 : 28,
  captionSize: !isMobile() ? 14 : 13,
  lang: 'en',
  countdown: true
});